document.addEventListener("DOMContentLoaded", () => {
    const header = document.querySelector("header");
    const navToggle = document.querySelector("[data-nav-toggle]");
    const navPanel = document.querySelector("[data-nav-panel]");

    if (header) {
        const updateHeaderState = () => {
            const navShell = header.querySelector(".luxury-nav");
            if (!navShell) return;
            if (window.scrollY > 16) {
                navShell.classList.add("is-scrolled");
            } else {
                navShell.classList.remove("is-scrolled");
            }
        };

        updateHeaderState();
        window.addEventListener("scroll", updateHeaderState);
    }

    if (navToggle && navPanel) {
        navToggle.addEventListener("click", () => {
            const isOpen = navPanel.classList.toggle("hidden") === false;
            navToggle.setAttribute("aria-expanded", String(isOpen));
            navToggle.classList.toggle("is-open", isOpen);
            document.body.classList.toggle("overflow-hidden", isOpen);
        });

        navPanel.querySelectorAll("a").forEach((link) => {
            link.addEventListener("click", () => {
                navPanel.classList.add("hidden");
                navToggle.classList.remove("is-open");
                navToggle.setAttribute("aria-expanded", "false");
                document.body.classList.remove("overflow-hidden");
            });
        });
    }
});
